
class Table3Lib {

  public _getIndexNameByCellType(cellType: string, index: string) {
    switch (cellType) {
      case "sno":
        return "__sno";
      default:
        return index || "";
    }
  }

  public defaults: any = {
    grid: {
      height: "300px"
    }
  }
  public swap(obj1, obj2, prop, sortDir) {
    return ((sortDir == 'A' && obj1[prop] > obj2[prop]) || (sortDir == 'D' && obj1[prop] < obj2[prop]));
  }
  public doSorting(columns, rows, col, sortDir = "") {
    let srws = rows.map(x => Object.assign({}, x)),
      sort = true;
    while (sort) {
      sort = false;
      for (let i = 0, j = 1; i < srws.length - 1; i++ , j++) {
        let obj1 = srws[i],
          obj2 = srws[j];
        if (this.swap(obj1, obj2, col.prop, sortDir)) {
          srws[j] = obj1,
            srws[i] = obj2;
          sort = true;
        }
      }
    }
    return srws;
  }
}

import { Component, Injectable, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'table3',
  templateUrl: './table3.component.html'
})

@Injectable()
export class Table3 extends Table3Lib implements OnInit {
  static table2_id = 0;
  gridOptions: any;
  tableHistory: any;
  tableData: any;
  checked:any;
  list:any= []; 
  public selectAll = true;
  showButton: boolean = false;
  @Input()
  set options(val: string) {
    let saveHistory = false;
    if (val['data']) {
      saveHistory = true;
    } else {
      val['data'] = [];
    }
    this.gridOptions = Object.assign(this.gridOptions, val);
    this.gridOptions.actionRow = true;

    if (val['columns']) {
      this.renderColumns();
    }
    this.start();
    if (val['columns']) {
      this.applyStyle();
    }
    this.applyCSS();
    if (saveHistory) {
      this.saveHistory();
    }

  }
  get options() {
    return this.gridOptions;
  }
  @Output() onCellClick: EventEmitter<any> = new EventEmitter<any>();
  @Output() prevClick: EventEmitter<any> = new EventEmitter<any>();

  tableId: number;
  constructor() {
    super();
    this.tableId = Table3.table2_id++;
    this.gridOptions = {
      loading: false,
      tableId: this.tableId,
      height: this.defaults.grid.height
    }

    this.tableData = {
      columns: [],
      dispRows: [],
      summaryrow: {},
      rows: [],
      sortBy: '',
      sortDir: 'A'
    }

    this.tableHistory = {
      ind: -1,
      data: []
    }
  }
  ngOnInit() {
    //c//onsole.log('Table2-' + this.tableId + ' Created.');
  }
  cellClicked(row, col, prop, value, rindex, cindex) {

    this.onCellClick.emit({
      row: row,
      column: col,
      property: prop,
      value: value,
      rowIndex: rindex,
      columnIndex: cindex
    });
    this.showButton = true;
  }

  loadNextData() {


    let tabHistory = this.tableHistory;
    if (tabHistory.ind < (tabHistory.data.length - 1)) {
      tabHistory.ind++;
      this.tableData = Object.assign({}, tabHistory.data[tabHistory.ind]);
    }
  }
  loadPrevData(row, col, prop, value, rindex, cindex) {

    let tabHistory = this.tableHistory;

    tabHistory.data.splice(-1);
    if (tabHistory.ind > 0) {
      tabHistory.ind--;
      this.tableData = Object.assign({}, tabHistory.data[tabHistory.ind]);
    }
    this.prevClick.emit({
      row: row,
      column: col,
      property: prop,
      value: value,
      rowIndex: rindex,
      columnIndex: cindex
    });
    this.showButton = false;
  }
  start(style: boolean = true) {
    this.renderRows();
    this.getSummaryRow();
    // this.applyCSS();
  }

  saveHistory() {
    let tabHistory = this.tableHistory;
    tabHistory.ind++;
    if (tabHistory.ind > 0 && tabHistory.ind < tabHistory.data.length) {
      //      tabHistory.data.splice(tabHistory.ind +1, tabHistory.data.length - tabHistory.ind-1);
    }
    tabHistory.data.push(Object.assign({}, this.tableData));
    tabHistory.ind = tabHistory.data.length - 1;
  }

  renderColumns() {
    this.tableData.columns = [];
    let data = this.gridOptions.data.map(x => Object.assign({}, x)),
      columns = this.gridOptions.columns.map(x => Object.assign({}, x)),
      cols = [],
      rows = [],
      row, ind, type, val,
      rlen = data.length,
      clen = columns.length;

    for (let i = 0; i < clen; i++) {

      let col = columns[i],
        name = col.name || "Column " + (i + 1),
        index = this._getIndexNameByCellType(col.type, col.index),
        width = col.width || 100,
        type = col.type || "value",
        gSummary = col.gSummary || "none",
        fSummary = col.fSummary || "none",
        cellClass = col.cellClass || "",
        headerClass = col.headerClass || "";

      cols.push({
        name: name,
        prop: col.prop,
        index: index,
        summaryClass: (col.summary == 'sum') ? 'txtRight' : '',
        type: type,
        summary: col.summary || 'none',
        cellClass: cellClass,
        headerClass: headerClass,
        width: width + "px",
        gSummary: gSummary,
        fSummary: fSummary
      });
    }
    this.tableData.columns = cols;

  }
  doSelectAll() {
    const list = this.tableData.rows; 
    for(let i=0; i<list.length;i++) {
      list[i].addTotal = this.selectAll;
    }
    this.getSummaryRow();
  }
  renderRows() {
    this.selectAll = true;
    let data = this.gridOptions.data.map(x => Object.assign({}, x)),
    columns = this.gridOptions.columns.map(x => Object.assign({}, x)),
      cols = this.tableData.columns,
      rows = [],
      row, ind, type, val,
      rlen = data.length,
      clen = columns.length;
    for (let i = 0; i < rlen; i++) {
      row = Object.assign({}, data[i]);
      for (let j = 0; j < clen; j++) {
        let type = cols[j].type,
          index = cols[j].index,
          prop = cols[j].prop;
        switch (type) {
          case "sno":
            val = i + 1;
            row[prop] = val;
            break;
          case "date":

            break;
          default:
            break;
        }
      }
      row.addTotal = true;
      rows.push(row);
    }

    this.tableData.rows = rows;
    this.tableData.dispRows = this.tableData.rows.map(x => Object.assign({}, x));
  }

  getDateFormat(date) {
    let d = date.split("-"),
      fd = d[2] + "-" + d[1] + "-" + d[0];
    return fd;
  }

  moneyFormat(nStr) {
    if (nStr == null || nStr == undefined || nStr == "" || nStr == 0)
        return 0.00;
    let no = parseFloat(nStr).toFixed(2);
    /*if (no < 0) {
        nStr = no * -1;
    }
    nStr += '';*/

    let x = no.split('.');
    let x1 = x[0];
    let x2 = x.length > 1 ? '.' + x[1] : '';
    let rgx = /(\d+)(\d{3})/;
    let z = 0;
    let len = (x1).length;
    let num = ((len / 2) - 1);
    let newval = Math.floor(num);

    while (rgx.test(x1)) {
        if (z > 0) {
            x1 = x1.replace(rgx, '$1' + ',' + '$2');
        } else {
            x1 = x1.replace(rgx, '$1' + ',' + '$2');
            rgx = /(\d+)(\d{2})/;
        }
        z++;
        newval--;
        if (newval == 0) {
            break;
        }
    }

    let out = x1 + x2;
     if (Number(no) < 0) {
         out = "(" + out + ")";
     }
    return out;

}


  getSummaryRow() {
    let data = this.tableData.rows,
      columns = this.tableData.columns,
      row = {
        type: "summary"
      }
    for (let i = 0; i < columns.length; i++) {
      let col = columns[i];
      switch (col.summary) {
        case "sum":
          let total = 0;
          for (let j = 0; j < data.length; j++) {
            let dat = data[j],
              val = parseFloat(dat[col.prop]);
            val = (isNaN(val)) ? 0 : val;
            if(!dat.addTotal) {
              continue;
            }
            total += val;
          }
          row[col.prop] = Math.round(total * 100) / 100;
          row[col.prop] = this.moneyFormat(row[col.prop]);
          break;
        default:
          row[col.prop] = '';
          break;
      }
    }
    this.tableData.summaryrow = row;
    //this.tableData.summaryrow = parseFloat(this.tableData.summaryrow);
  }

  sort(col) {
    this.gridOptions.loading = true;
    let cprop = col.prop,
      sortBy = this.tableData.sortBy,
      rows = this.tableData.rows,
      cols = this.tableData.columns,
      sortDir = this.tableData.sortDir;
    if (cprop === sortBy) {
      switch (sortDir) {
        case 'A':
          sortDir = 'D';
          break;
        case 'D':
          sortDir = '';
          break;
        default:
          sortDir = 'A';
          break;
      }
    } else {
      sortBy = cprop;
      sortDir = 'A';
    }
    this.tableData.sortBy = sortBy;
    this.tableData.sortDir = sortDir;
    let that = this;
    setTimeout(function () {
      let dispRows = that.doSorting(cols, rows, col, sortDir);
      that.tableData.dispRows = dispRows;
      that.gridOptions.loading = false;
    }, 200);
  }
  applyStyle() {
  }

  applyCSS() {
    let that = this;
    setTimeout(function () {
      let tid = that.tableId,
        scrollDiv = "#t2-" + tid + " .t2-canvas.t2-cf",
        hDiv = "#t2-" + tid + " .t2-canvas.t2-ch",
        bDiv = "#t2-" + tid + " .t2-canvas.t2-cb",
        footDiv = "#t2-" + tid + " #t2-foot-div",
        footDivTable = "#t2-" + tid + " #t2-foot-div table",
        width = $(footDivTable).width() + 1;
      $(footDiv).width(width + "px");

      document.querySelector(scrollDiv)['onscroll'] = function () {
        let left = document.querySelector(scrollDiv).scrollLeft;
        document.querySelector(hDiv).scrollLeft = left,
          document.querySelector(bDiv).scrollLeft = left;
      };
      width = that.gridOptions.maxHeight || "300px";
      let cb = document.querySelector("#t2-" + tid + " .t2-canvas.t2-cb");
      cb['style'].maxHeight = width;
      cb['style'].minHeight = width;
      document.querySelector("#t2-" + tid + " .t2-canvas.t2-cb")['style'].overflowY = "scroll";
      "scroll";
    }, 700);
  }

  a(checked,data) {
     
     if(checked == true){
     this.list.push(data);
     }
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/common/table3/table3.component.ts